<template>
  <section class="reporting-container-wrapper">
    <div class="d-flex justify-space-between">
      <div class="tab-header">
        <h3 class="mb-0 mt-1">
          <fai :icon="['fas', 'download']" class='mr-1' />feedback report: {{ contentTitle.toLowerCase() }}
        </h3>
      </div>
    </div>

    <div class="d-flex align-center justify-start">
      <hr style="margin: 10px -15px 10px -15px; width: 100%; min-width: 880px" />
    </div>

    <div>
      <section>
        <div class="row">
          <div class="col-md-12 options">
            <div class="d-flex justify-space-between align-center">

              <!-- Step 1 Box -->
              <div
                class="d-flex flex-column align-center justify-middle option-box-wrapper mx-3"
                >
                <div
                  class="d-flex align-center justify-start mb-2 pb-1 border-bottom w-100"
                >
                  <label class="label my-0">step 1:</label>
                  <div class="align-center my-0"><b>select number of days</b></div>
                </div>
                <div class="d-flex align-center justify-start px-3 mx-3">
                  <div class="d-flex flex-row justify-start align-center">
                    <div class="form-group mb-0">
                      <div class="input-group">
                        <div id="filter-id"/>
                        <select
                          class="form-control input"
                          @input="
                            event => {
                              filterHandler('day', event.target.value);
                            }
                          "
                        >
                          <option
                            v-for="(option, index) in days"
                            :selected="option.value == dataConfig.params.days"
                            :value="option.value"
                            :key="index"
                          >
                            {{ option.name }}
                          </option>
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="d-flex align-center text-center px-3 mx-3">
                  <span class="small mt-3"
                    >feedback from {{ handleDynamicText('day').toLowerCase() }}
                  </span>
                </div>
              </div>

              <!-- Step 2 Box -->
              <div
                class="d-flex flex-column align-center justify-middle option-box-wrapper mx-3"
                >
                <div
                  class="d-flex align-center justify-start mb-2 pb-1 border-bottom w-100"
                >
                  <label class="label my-0">step 2:</label>
                  <div class="align-center my-0"><b>select feedback type</b></div>
                </div>

                <div class="d-flex align-center justify-start px-3 mx-3">
                  <div class="d-flex justify-start align-center">
                    <div class="d-flex flex-row justify-start align-center">
                      <div class="form-group mb-0">
                        <div class="input-group">
                          <div id="tagged-items-filter-id">
                            
                          </div>
                          <select
                            class="form-control input"
                            @input="
                              event => {
                                filterHandler('tag', event.target.value);
                              }
                            "
                          >
                            <option
                              v-for="(option, index) in tags"
                              :value="option.value"
                              :key="index"
                            >
                              {{ option.name }}
                            </option>
                          </select>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="d-flex align-center justify-start px-3 mx-3">
                  <span class="small mt-3">displaying {{handleDynamicText('tag')}}</span>
                </div>
              </div>

              <!-- Step 3 Box -->
              <div
                class="d-flex flex-column align-center justify-middle option-box-wrapper mx-3"
                >
                <div
                  class="d-flex align-center justify-start mb-2 pb-1 border-bottom w-100"
                >
                  <label class="label my-0">step 3:</label>
                  <div class="align-center my-0"><b>select sort order</b></div>
                </div>
                <div class="d-flex align-center justify-start mt-1 mb-1 px-3 mx-3">
                  <div class="d-flex flex-row justify-start align-center">
                    <div class="d-flex align-center">
                      <div class="sort-order-wrapper">
                        <a
                          id="sort-order"
                          v-if="dataConfig.params.sort == 'DESC'"
                          @click="filterHandler('sort', 'ASC')"
                          class="desc btn-down"
                        >
                          newest first <fai :icon="['far', 'chevron-down']" class="ml-1"/>
                        </a>
                        <a
                          id="sort-order"
                          v-if="dataConfig.params.sort == 'ASC'"
                          @click="filterHandler('sort', 'DESC')"
                          class="asc btn-up"
                        >
                          oldest first <fai :icon="['far', 'chevron-up']" class="ml-1"/>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="d-flex align-center justify-start px-3 mx-3">
                  <span class="small mt-3">order feedback by created date {{ handleDynamicText('sort') }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12">
            <hr style="margin: 10px -5px 10px -5px;" />
          </div>
        </div>

        <div class="row">
          <div class="col-md-12 d-flex justify-center">
            <div class="d-flex justify-space-around align-center">
              <div
                class="d-flex flex-column align-center justify-middle option-box-wrapper mx-3"
              >
                <div
                  class="d-flex align-center justify-start mb-2 pb-1 border-bottom w-100"
                >
                  <label class="label my-0">step 4:</label>
                  <div class="align-center my-0">
                    <b>confirm title and choose format</b>
                  </div>
                </div>

                <div class="text-center mx-auto">
                  <div class="d-flex justify-space-around align-center mx-3 my-3">
                    <div class="d-flex justify-center" v-if="showLoading">
                      <sb-loading-icon />
                    </div>
                    <div v-else class="d-flex flex-column align-center justify-center">
                      <div class="mt-1 mb-2">
                        <h4 class="my-0 text-center">{{handleDynamicText('tag')}} from the last {{dataConfig.params.days}} days ordered {{dataConfig.params.sort.toLowerCase()}}</h4>
                        <h4 class="my-1 mx-2">
                          {{totalRecordCount}} total records & 
                          {{estimatedPageCount}} estimated pages
                        </h4>
                      </div>

                      
                      <div class="text-center d-flex mb-5">
                        <btn
                          class="mx-auto shrink btn bg-blue mr-2"
                          id="openPDF"
                          type="success"
                          size="sm"
                          v-on:click="handleAction('OPEN')"
                          :disabled="loading"
                          >
                          <fai :icon="['fas', 'external-link-alt']" class='mr-1'/>
                          open pdf
                        </btn>
                        <btn
                          class="btn bg-blue mr-2"
                          id="downloadPDF"
                          type="success"
                          size="sm"
                          v-on:click="handleAction('DOWNLOAD')"
                          >
                          <fai :icon="['fas', 'download']" class='mr-1'/>
                          download pdf
                        </btn>

                        <btn
                          class="btn bg-blue"
                          id="csvPDF"
                          type="success"
                          size="sm"
                          v-on:click="handleAction('CSV')"
                          >
                          <fai :icon="['fas', 'download']" class='mr-1'/>
                          download csv
                        </btn>
                      </div>
                      <div>
                        <p class="small mb-0">
                          adblock software may sometimes prevent the report from opening properly in a new window.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  </section>
</template>

<script>
import { feedbackAPI } from "../../../../services/api/feedbackAPI"

//Components
import { Btn } from "uiv";

//PDF Report creation
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
pdfMake.vfs = pdfFonts.pdfMake.vfs;

//Our report utility
import pdfReportFormatter from "../pdf/pdfReportFormatter.js";

export default {
  name: "ReportingContainer",
  components: {
    Btn
  },
  data() {
    return {
      days: [
        {
          value: "3",
          name: "last 3 days"
        },
        {
          value: "7",
          name: "last 7 days"
        },
        {
          value: "14",
          name: "last 14 days"
        },
        {
          value: "30",
          name: "last 30 days"
        }
      ],
      tags: [
        {
          value: "all",
          name: "all important"
        },
        {
          value: "open",
          name: "opened"
        },
        {
          value: "resolved",
          name: "resolved"
        },
        {
          value: "flagged",
          name: "flagged"
        }
      ],
      names: {
        organization: "Organization Name",
        region: "Region Name",
        store: "Store Name"
      },
      fileName: "ImportantFeedbackReport",
      loading: false,
      feedback: [],
      csvData: [],
      dataConfig: {
        params: {
          days: 7,
          tagType: 'all',
          sort: 'DESC'
        }
      },
      showLoading: true
    };
  },
  async created() {
    this.feedback = await feedbackAPI.GETFeedbackReport(this.dataConfig)
    this.names.organization = await feedbackAPI.GETOrganizationInfo()
    this.getRegionInfo()
    this.getStoreInfo()

    this.$root.$on("setStore", () => {
      this.refresh()
      this.getStoreInfo()
      this.getRegionInfo()
    });
    this.showLoading = false
  },
  computed: {
    totalRecordCount() {
      return this.feedback.length;
    },
    estimatedPageCount() {
      const length = this.feedback.length
      const perPage = 5; //about 5 per page

      if (length == 0) return 0;
      return Math.ceil(length / perPage) + 1;
    },
    contentTitle() {
      const { names } = this

      if(names.store != "Store Name") {
        return names.store
      } else if (names.region != "Region Name") {
        return names.region
      } else {
        return names.organization
      }
    }
  },
  methods: {
    async refresh() {
      this.showLoading = true
      this.feedback = await feedbackAPI.GETFeedbackReport(this.dataConfig)
      this.showLoading = false
    },
    filterHandler: function(filter, val) {
      switch(filter) {
        case 'day':
          this.dataConfig.params.days = val;
          break;
        case 'tag':
          this.dataConfig.params.tagType = val;
          break;
        case 'sort':
          this.dataConfig.params.sort = val;
          break;
      }

      this.dataConfig.params.page = 1
      this.refresh();
    },
    handleDynamicText(filter) {
      switch(filter) {
        case 'day':
          const today = new Date();
          const prevDate = new Date(
            today.getFullYear(), 
            today.getMonth(),
            today.getDate()-this.dataConfig.params.days);
          return `${prevDate.toDateString().slice(4)} to ${today.toDateString().slice(4)}`
          break;
        case 'tag':
          if(this.dataConfig.params.tagType == 'all') {
            return 'all important feedback';
          } else {
            return `feedback tagged as ${this.dataConfig.params.tagType}`
          }
          break;
        case 'sort':
          if(this.dataConfig.params.sort == 'DESC') return 'newest first';
          if(this.dataConfig.params.sort == 'ASC') return 'oldest first';
          break;
      }
    },
    getRegionInfo() {
      if(localStorage.budtender_region_name) {
        this.names.region = localStorage.budtender_region_name
      } else {
        this.names.region = "Region Name"
      }
    },
    getStoreInfo() {
      if(localStorage.budtender_store_name) {
        this.names.store = localStorage.budtender_store_name
      } else {
        this.names.store = "Store Name"
      }
    },
    async handleAction(action) {
      if (action=='CSV') {
        this.downloadAsCsv()
      } else {
        await this.refresh()

        try {
          if (this.feedback.length != 0) {
            const docDefinition = pdfReportFormatter.create(this.feedback, {
              organizationName: this.organizationName,
              regionName: localStorage.region_name,
              storeName: localStorage.store_name,
              reportRange: this.dataConfig.params.days,
              reportParamString: `${this.handleDynamicText('tag')} from the last ${this.dataConfig.params.days} days ordered ${this.dataConfig.params.sort.toLowerCase()}`
            });

            switch (action) {
              case "OPEN":
                pdfMake.createPdf(docDefinition).open();
                break;
              case "DOWNLOAD":
                pdfMake.createPdf(docDefinition).download(`${this.fileName}.pdf`);
                break;
              default:
            }
          }          
        } catch (err) {
        }
      }
    },
    async downloadAsCsv() {
      try {
        const isCsv = true
        this.csvData = await feedbackAPI.GETFeedbackReport(this.dataConfig, isCsv)

        const anchor = document.createElement("a");
        const filename = this.csvData[0];

        anchor.setAttribute("download", filename);
        anchor.setAttribute("href", this.csvData[1]);
        anchor.setAttribute("target", "_blank");
        anchor.setAttribute("rel", "noreferrer noopener")

        document.body.appendChild(anchor);
        anchor.click();
        document.body.removeChild(anchor);

        this.deleteCsv(filename)
      } catch (err) {
      }
    },
    async deleteCsv(csvfile) {
      setTimeout(function(csvfile) {
        feedbackAPI.DELCsvReport({
          params: { 
            filename: csvfile
          }
        })
      },1000, csvfile)  
    }
  }
};
</script>